import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-write-comment',
  templateUrl: './write-comment.component.html',
  styleUrls: ['./write-comment.component.scss'],
})
export class WriteCommentComponent implements OnInit, OnDestroy {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  commentForm: UntypedFormGroup;
  submitted: boolean;
  title: string;
  isMandatory: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<WriteCommentComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.title = data.title;
    if (!_.isNil(data.isMandatory)) {
      this.isMandatory = data.isMandatory;
    }
  }

  get IsFormValid(): boolean {
    return this.commentForm.valid;
  }

  ngOnInit(): void {
    this.buildFormControls();
  }

  buildFormControls(): void {
    this.commentForm = this.formBuilder.group({
      Comment: new UntypedFormControl(
        { value: '' },
        this.isMandatory ? [Validators.required] : []
      ),
    });
    this.commentForm.patchValue({ Comment: '' });
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  close(isSuccess: boolean) {
    this.dialogRef.close({ isSuccess: isSuccess, data: '' });
  }

  onSubmit = () => {
    if (this.IsFormValid) {
      this.dialogRef.close({
        isSuccess: true,
        data: this.commentForm.controls.Comment.value,
      });
    }
  };
}
